import { useCallback, useLayoutEffect } from 'react';

import { bindAll } from 'bind-event-listener';

import { fg } from '@atlaskit/platform-feature-flags';

export const useEscapeKey = (
	ref: React.RefObject<HTMLElement | null>,
	onEscape: () => void,
): void => {
	useLayoutEffect(() => {
		const el = ref.current;
		if (!el) {
			return;
		}

		if (!fg('platform_editor_ai_scroll_into_view_fix')) {
			el.scrollIntoView({ block: 'nearest', behavior: 'auto' });
		}

		return bindAll(el, [
			{
				type: 'keydown',
				listener: (e: KeyboardEvent) => {
					if (e.key !== 'Escape') {
						return;
					}
					e.preventDefault();
					e.stopPropagation();
					onEscape();
				},
			},
			{
				type: 'keyup',
				listener: (e: KeyboardEvent) => {
					if (e.key !== 'Escape') {
						return;
					}
					e.preventDefault();
					e.stopPropagation();
				},
			},
		]);
	}, [ref, onEscape]);
};

export const useSubmitControls = (submit: () => void, text?: string) => {
	const isDisabled = Boolean(text?.trim().length === 0);

	const onKeyDown = useCallback(
		(e: React.KeyboardEvent): void => {
			if (e.key === 'Enter' && !e.shiftKey && !isDisabled) {
				e.preventDefault();
				submit();
			}
		},
		[isDisabled, submit],
	);

	return { isDisabled, onKeyDown };
};
